<template>
  <div>
    <div class="px-2 my-4 flex justify-between items-center">
      <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">
        {{ title }}
      </h1>
    </div>

    <div class="my-5 px-4 py-2 bg-white shadow rounded-lg" v-if="storeOptions.length > 1">
      <Selector
        id="store"
        label="Magasin"
        name="store"
        required
        v-model="currentStoreId"
        :options="storeOptions"
        class="mb-5"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { Selector } from "@estaly/ui";

export default {
  components: {
    Selector,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  created() {
    this.currentStoreId = this.$route.query.storeId || this.selectedStoreId || this.filteredStores[0]?.id;
  },

  computed: {
    ...mapState("store", ["stores"]),
    ...mapState("retributionConfigurations", ["selectedStoreId"]),

    currentStoreId: {
      get() {
        return this.selectedStoreId;
      },
      async set(value) {
        this.setSelectedStoreId(value);

        const url = new URL(location);
        url.searchParams.set("storeId", value);
        history.pushState({}, "", url);

        await this.fetchRetributionConfigurations();
      },
    },

    filteredStores() {
      return this.stores.filter((store) => store.source === "offline" && store.status === "active");
    },

    storeOptions() {
      return this.filteredStores.map((store) => ({
        label: store.salesChannel,
        value: store.id,
      }));
    },

    store() {
      return this.stores.find((store) => store.id == this.selectedStoreId);
    },
  },

  methods: {
    ...mapActions("retributionConfigurations", ["fetchRetributionConfigurations"]),
    ...mapMutations("retributionConfigurations", ["setSelectedStoreId"]),
  },
};
</script>
